/**
 * Owned illustration palette for the glossy toast spheres. These colors are
 * intentionally not semantic status tokens: the adjacent icon and copy carry
 * meaning, while the sphere art stays visually identical across themes.
 */
export const STATUS_SPHERE_PALETTE = {
  error: {
    base: "#F57070",
    tint: "#FF5A5A",
  },
  success: {
    base: "#7BE7AE",
    tint: "#3BF292",
  },
  warning: {
    base: "#F7BE6B",
    tint: "#F7931A",
  },
} as const;
